<template>
	<v-row no-gutters>
		<v-row no-gutters align="center" style="margin-top: -10px">
			<template v-if="chartPointDetail">
				<v-btn icon color="primary" @click="hidePointDetail">
					<v-icon color="primary">mdi-chevron-left</v-icon>
				</v-btn>
				<v-spacer></v-spacer>
				{{pointDetail.date.toLocaleDateString('en',{month: 'short', day: 'numeric', year: 'numeric'})}}
			</template>
		</v-row>
		<div key="container" :id="'chartContainer' + id" style="height: 300px; width: 100%"></div>
	</v-row>
</template>

<script>
import CanvasJS from "@/assets/libs/canvasjs/canvasjs.min.js";

export default {
	name: "MonitoredSymptomChart",
	props: ["id","records"],
	data: () => ({
		chart: null,
		chartPointDetail: null,
		showPointDetail: false,
		pointDetail: null
	}),
	computed: {
		recordsFiltered() {
			const recordsByDate = {};
			this.records.forEach(r => {
				if (recordsByDate[r.date]) {
					recordsByDate[r.date].records.push(r);
					if (r.intensity > recordsByDate[r.date].max)
						recordsByDate[r.date].max = r.intensity;
					if (r.intensity < recordsByDate[r.date].min)
						recordsByDate[r.date].min = r.intensity;
					recordsByDate[r.date].total += r.intensity;
				} else
					recordsByDate[r.date] = {
						records: [r],
						max: r.intensity,
						min: r.intensity,
            total: r.intensity,
            date: new Date(r.date)
					};
			});
			for (var key in recordsByDate) {
				recordsByDate[key].average =
					recordsByDate[key].total / recordsByDate[key].records.length;
			}
			return recordsByDate;
		},
		chartOptions() {
			return {
				title: {
					text: ""
        },
        axisY:{
          minimum: 0,
          maximum: 10
        },
				axisX: {
					labelFormatter: function(e) {
						return CanvasJS.formatDate(e.value, "DD MMM");
					}
				},
				data: this.data
			};
		},
		data() {
      const mSC = this;
			const data = [
				{
          name: this.$gettext("Intensity"),
          color: mSC.$vuetify.theme.themes.light.primary.base,
					showInLegend: true,
					type: "spline",
					dataPoints: [],
					click: function(e) {
						mSC.changeShowPointDetail(e);
					}
				},
				{
					name: this.$gettext("Variation Range"),
					whiskerLength: 15,
					showInLegend: true,
					type: "error",
					dataPoints: []
				}
			];
			for (var key in this.recordsFiltered) {
				let r = this.recordsFiltered[key];
				let date = new Date(key);
				data[0].dataPoints.push({
					x: date,
					y: r.average,
					markerSize: 15,
					record: r
				});
				data[1].dataPoints.push({
					x: date,
					y: [r.min, r.max]
				});
			}
			return data;
		},
		pointDetailOptions() {
			return {
				title: {
					text: ""
        },
        axisY:{
          minimum: 0,
          maximum: 10
        },
				axisX: {
					labelFormatter: function(e) {
						return CanvasJS.formatDate(e.value, "HH:mm");
					}
				},
				data: this.pointDetailData
			};
		},
		pointDetailData() {
      const mSC = this;
			const data = [
				{
          name: this.$gettext("Intensity"),
          color: mSC.$vuetify.theme.themes.light.primary.base,
					showInLegend: true,
					type: "spline",
					dataPoints: []
				}
			];
			this.pointDetail.records.forEach(record => {
				let date = new Date(record.date + "T" + record.time);
				data[0].dataPoints.push({
					x: date,
					y: record.intensity,
					markerSize: 15
				});
			});
			return data;
		}
	},
	methods: {
		changeShowPointDetail(e) {
			this.pointDetail = e.dataPoint.record;
			this.chart = null;
			this.showPointDetail = true;
			this.chartPointDetail = new CanvasJS.Chart(
				"chartContainer" + this.id,
				this.pointDetailOptions
			);
			this.chartPointDetail.render();
		},
		hidePointDetail() {
			this.pointDetail = null;
			this.chartPointDetail = null;
			this.showPointDetail = false;
			this.chart = new CanvasJS.Chart("chartContainer" + this.id, this.chartOptions);
			this.chart.render();
		}
	},
	mounted() {
		console.log("MOUNTED");
		this.chart = new CanvasJS.Chart("chartContainer" + this.id, this.chartOptions);
		this.chart.render();
  },
  watch: {
    records() {
      console.log("change");
      if(!this.showPointDetail){
        this.chart = new CanvasJS.Chart("chartContainer" + this.id, this.chartOptions);
      } else {
        this.chart = new CanvasJS.Chart("chartContainer" + this.id, this.pointDetailOptions);
      }
      this.chart.render();
    }
  }
};
</script>

<style scoped>
>>> .canvasjs-chart-credit {
	display: none;
}
</style>